import { Text } from '@bit/ume.design-kit.ui'
import { Box } from 'grommet'
import * as React from 'react'
import { IconBox } from './style'
import { red } from '@bit/ume.design-kit.ui/utils/_colors'
import { Info } from 'grommet-icons'

export interface IErrorStringProps {
  text: string
}

export default class ErrorString extends React.Component<IErrorStringProps> {
  public render() {
    return (
      <Box direction="row" align="center">
        <IconBox align="center">
          <Info width="12px" color={red.persian} />
        </IconBox>

        <Text size="xsmall" light color={red.persian}>
          {this.props.text}
        </Text>
      </Box>
    )
  }
}
